module.exports = __webpack_public_path__ + "assets/img/6675d087d988fae1a9ab7ae61cdcda6d.png";